<template>
  <div>
    <h5 class="mb-4">합동점검일지</h5>
    <search-nav size="mobile" align="justify-end" @handleSearch="handleSearch">
      <search-nav-item-date class="w-full" size="mobile" label="점검일자" v-model="nav.date" />
      <search-nav-item-keyword class="w-full" size="mobile" label="키워드" v-model="nav.keyword"></search-nav-item-keyword>
    </search-nav>
    <div class="flex mb-4" style="justify-content: flex-end;">
      <vs-button class="w-1/2 px-0 mr-2" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
      <vs-button class="w-1/2 px-0 " color="secondary" @click="handleClickRegister">신규작성</vs-button>
    </div>
    <div style="margin:0 -1.2rem;">
      <vs-table
        style="border:1px solid #cdcdcd; border-radius: 0;"
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="table.list"
        noDataText="'대상기간' 을 선택하거나, 키워드 검색을 진행하여 주세요."
        @sort="handleSort"
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th sort-key="id" style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
          <vs-th sort-key="content$preview.title" style="min-width:130px;"><span class="w-full text-center">제목</span></vs-th>
          <vs-th sort-key="content$preview.checkDate" style="min-width:130px;"><span class="w-full text-center">점검일</span></vs-th>
          <vs-th sort-key="content$preview.writer" style="min-width:130px;"><span class="w-full text-center">작성자</span></vs-th>
          <vs-th sort-key="status" style="min-width:130px;"><span class="w-full text-center">결재상태</span></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center">{{ tr.post_id }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).title }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).checkDate }}</vs-td>
            <vs-td class="text-center">{{ getPreview(tr).writer }}</vs-td>
            <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleChangePage"></k-pagination>
        </div>
      </div>
    </div>

    <popup-approval-process
      :show-popup="showApprovalLinePopup"
      @closePopup="handleCloseApprovalPopup" />
  </div>
</template>

<script>
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import KPagination from '@/views/components/kPagination/kPagination'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
export default {
  name: 'MobileSafetyDailyCheckLogAll',
  components: {
    PopupApprovalProcess,
    KPagination,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  computed: {
    rootPath () {
      const paths = this.$route.path.split('/')
      return `/${paths[1]}/${paths[2]}/${paths[3]}`
    }
  },
  data () {
    return {
      // 검색 네비게이션
      nav:{
        date:['', ''],
        orderNum:'',
        keyword:'',
        dateTarget: 'content$preview.checkDate',
        orderTarget:'created_at',
        orderDirection:'desc'
      },

      currentPage: 1,
      lastPage: 1,
      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },

      showApprovalLinePopup : false
    }
  },
  created () {
    this.loadPostList()
  },

  methods: {

    async loadPostList () {
      const projectId = this.$route.params.proj_id
      const boardSlug = 'joint_check_diary' // first_risk(id:6)
      const page = this.currentPage
      const perPage = this.table.perPage
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      const dateTarget = []
      const dateBegin = []
      const dateEnd = []
      const keyword = []
      if (this.nav.dateTarget) dateTarget.push(this.nav.dateTarget)
      if (this.nav.date[0]) dateBegin.push(this.nav.date[0])
      if (this.nav.date[1]) dateEnd.push(this.nav.date[1])

      if (this.nav.keyword) keyword.push(this.nav.keyword)

      await this.$store.dispatch('approval/LOAD_POST_ALL', {projectId, boardSlug, keyword, page, perPage, orderTarget, orderDirection, dateTarget, dateBegin, dateEnd})

      this.table.list = this.$store.state.approval.list
      const listInfo = this.$store.state.approval.postListInfo
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page
    },

    handleSearch () {
      this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },
    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },

    handleItemClickDetail (data) {
      if (data.post_id) {
        this.$router.push(`${data.post_id}/daily-checklogall-update`)
      } else {
        this.$router.push(`${data.id}/daily-checklogall-update`)
      }
    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type
        this.loadPostList()
      }
    },

    handleClickRegister () {
      this.$router.push('daily-checklogall-create')
    }
  }
}
</script>

<style scoped>

</style>
